<template>
  <nav class="brand-nav bg-gray-900/95 text-white">
    <div class="container mx-auto px-4">
      <div class="flex justify-center items-center space-x-6 h-9">
        <!-- IT-Meeder (Aktiv) -->
        <router-link to="/" class="flex items-center space-x-1.5 px-3 py-1 rounded bg-primary/90 hover:bg-primary transition-colors brand-nav-link" :class="{'is-active': $route.path === '/'}">
          <img src="@/assets/it-meeder.png" alt="IT-Meeder Logo" class="h-4 w-auto" />
          <span class="font-medium text-sm">IT-MEEDER</span>
        </router-link>

        <!-- PC-Meeder (Coming Soon) -->
        <router-link to="/pc-meeder" class="flex items-center space-x-1.5 px-3 py-1 rounded bg-gray-800/80 hover:bg-gray-800 transition-colors relative brand-nav-link" :class="{'is-active': $route.path === '/pc-meeder'}">
          <QuestionMarkCircleIcon class="h-4 w-4 text-gray-400" />
          <span class="font-medium text-sm text-gray-400">PC-MEEDER</span>
          <span class="absolute -bottom-1.5 -right-1.5 bg-yellow-500/90 text-black text-[10px] px-1.5 py-px rounded-full">Soon</span>
        </router-link>

        <!-- Edu-Meeder (Coming Soon) -->
        <router-link to="/edu-meeder" class="flex items-center space-x-1.5 px-3 py-1 rounded bg-gray-800/80 hover:bg-gray-800 transition-colors relative brand-nav-link" :class="{'is-active': $route.path === '/edu-meeder'}">
          <AcademicCapIcon class="h-4 w-4 text-gray-400" />
          <span class="font-medium text-sm text-gray-400">EDU-MEEDER</span>
          <span class="absolute -bottom-1.5 -right-1.5 bg-yellow-500/90 text-black text-[10px] px-1.5 py-px rounded-full">Soon</span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { QuestionMarkCircleIcon, AcademicCapIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'BrandNav',
  components: {
    QuestionMarkCircleIcon,
    AcademicCapIcon
  }
}
</script>

<style scoped>
.brand-nav {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

/* Aktiver Link Styling */
.brand-nav-link.is-active {
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

/* Responsive Anpassungen */
@media (max-width: 640px) {
  .brand-nav .container {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  
  .brand-nav .space-x-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }
  
  .brand-nav .px-3 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
</style> 